export enum PeriodPartSelectionEnum {
    FullPeriod = 0,
    OnlyWorkDays = 1,
    OnlyWeekend = 2
}
